(function () {
  "use strict";
  var D = document;
  var $ = function (id) { return D.getElementById(id); };

  /* ---- sticky header ---- */
  var hdr = $("hdr");
  if (hdr) {
    addEventListener("scroll", function () {
      hdr.classList.toggle("stuck", scrollY > 8);
    }, { passive: true });
  }

  /* ---- satin sheen follows the pointer, transform only ---- */
  if (!matchMedia("(prefers-reduced-motion: reduce)").matches) {
    D.querySelectorAll(".dusk").forEach(function (el) {
      el.addEventListener("pointermove", function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty("--sheen", ((e.clientX - r.left) / r.width * 30 - 15) + "%");
      });
      el.addEventListener("pointerleave", function () {
        el.style.setProperty("--sheen", "0");
      });
    });
  }

  /* ---- product gallery ---- */
  var main = $("p-img");
  D.querySelectorAll(".p-thumbs button").forEach(function (b) {
    b.addEventListener("click", function () {
      if (!main) return;
      main.src = b.dataset.src;
      main.removeAttribute("srcset");
      D.querySelectorAll(".p-thumbs button").forEach(function (o) {
        o.removeAttribute("aria-current");
      });
      b.setAttribute("aria-current", "true");
    });
  });

  /* ---- variant tiers: buttons, not a dropdown ---- */
  var tiers = D.querySelectorAll(".tier");
  var vid = $("vid"), now = $("p-now"), unit = $("p-unit"), sPrice = $("s-price");
  tiers.forEach(function (t) {
    t.addEventListener("click", function () {
      if (t.disabled) return;
      tiers.forEach(function (o) { o.setAttribute("aria-checked", "false"); });
      t.setAttribute("aria-checked", "true");
      if (vid) vid.value = t.dataset.id;
      if (now) now.textContent = t.dataset.price;
      if (sPrice) sPrice.textContent = t.dataset.price;
      if (unit && t.dataset.unit) {
        unit.textContent = unit.textContent.replace(/^[^ ]+/, t.dataset.unit);
      }
    });
  });

  /* ---- sticky buy bar, revealed once the tiers scroll past ---- */
  var sticky = $("sticky"), anchor = $("tiers");
  if (sticky && anchor && "IntersectionObserver" in window) {
    new IntersectionObserver(function (e) {
      var past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      sticky.classList.toggle("up", past);
      sticky.setAttribute("aria-hidden", !past);
    }, { rootMargin: "-90px 0px 0px 0px" }).observe(anchor);
  }
  D.querySelectorAll("[data-jump]").forEach(function (b) {
    b.addEventListener("click", function () {
      var t = $(b.dataset.jump);
      if (t) t.scrollIntoView({ block: "center" });
    });
  });

  /* ---- email capture ----
     NN/g lists "email requests too early" among the worst popup patterns, so
     this waits for real engagement: a scroll past one viewport AND 20s, or an
     exit-intent. Once dismissed it stays dismissed. */
  var pop = $("pop"), veil = $("veil");
  if (pop && veil) {
    var KEY = "rolyne_pop", seen = false, engaged = false;
    try { seen = localStorage.getItem(KEY) === "1"; } catch (e) {}

    var close = function () {
      pop.hidden = veil.hidden = true;
      seen = true;
      try { localStorage.setItem(KEY, "1"); } catch (e) {}
    };
    var open = function () {
      if (seen || !engaged || !pop.hidden) return;
      pop.hidden = veil.hidden = false;
      var f = pop.querySelector("input");
      if (f) f.focus();
    };

    if (!seen) {
      addEventListener("scroll", function onScroll() {
        if (scrollY > innerHeight) {
          engaged = true;
          removeEventListener("scroll", onScroll);
          setTimeout(open, 20000);
        }
      }, { passive: true });
      D.addEventListener("mouseout", function (e) {
        if (e.clientY <= 0) open();
      });
    }
    ["pop-x", "pop-no"].forEach(function (id) {
      var el = $(id);
      if (el) el.addEventListener("click", close);
    });
    veil.addEventListener("click", close);
    addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !pop.hidden) close();
    });
  }
})();
